import './FleetBusiness.scss';
import Button from '../../../../../src/components/pages/ui/Button/Button';
import React from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { useMediaQuery } from 'usehooks-ts';

export default function FleetBusiness({ fields }) {
  const { titleRichText, image, mobileImage } = fields;
  const isMobile = useMediaQuery('(max-width: 480px)');
  let backgroundStyle = {
    backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0) 54.42%, #000000 100%), url(${image?.value?.src})`,
  };
  if (isMobile) {
    backgroundStyle = {
      backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0) 54.42%, #000000 100%), url(${mobileImage?.value?.src})`,
    };
  }

  return (
    <div className={'fleet-business-wrap'}>
      <div className={'container'}>
        <div style={backgroundStyle} className={'wrapper'} data-aos="fade-up">
          <div className={'inner'}>
            <div data-aos="fade-up" data-aos-offset={200}>
              <div className={'title'}>
                <RichText field={titleRichText} />
              </div>
              <div className={'text'}>
                <RichText field={fields.desc} />
              </div>
            </div>
            <div className={'buttonContainer'} data-aos="fade-up" data-aos-offset={200}>
              <Button className={'button'} isShowTooltip={false} target="/fleet-business">
                {fields.buttonText.value}
              </Button>
            </div>
          </div>
        </div>
        <div className={'buttonMobileContainer'} data-aos="fade-up">
          <Button className={'button'} isShowTooltip={false} target="/fleet-business">
            {fields.buttonText.value}
          </Button>
        </div>
      </div>
    </div>
  );
}
